import React from "react";
import Dashboard from "../Dashboard/Dashboard";

const Enrol = () => {
  return (
    <div className="w-full">
      {/* <Card className="max-w-xl overflow-hidden p-3 text-center">
        <CardTitle className="text-md mb-2 flex justify-center w-full items-center">
          AML/CTF Program Enrollment
        </CardTitle>

        <CardContent className="p-3 pt-2">
          <p>
            Enroll in AUSTRAC Anti-Money Laundering (AML) and Counter-Terrorism
            Financing (CTF) compliance regime to ensure your business meets
            legal obligations, reduces exposure to financial crime, and
            demonstrates a strong compliance culture.
          </p>
          <a
            href="https://www.austrac.gov.au/business/new-to-austrac/enrol-or-register"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button className="w-full mt-4">Enrol Now</Button>
          </a>
        </CardContent>
      </Card> */}
      <Dashboard />
    </div>
  );
};

export default Enrol;
